import { useEffect, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import {
  Button,
  Col,
  Form,
  Grid,
  Input,
  InputMask,
  Picker,
  Row,
  Span
} from 'components'
import {
  withDateColor,
  rangeIsInvalid,
  hasInvalidDate
} from 'components/DatePicker/utils'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import { useModal } from 'hooks'
import useLoading from 'hooks/useLoading'
import useToggle from 'hooks/useToggle'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import { CreParamsServices, ICreParams } from 'services/NGT/CreParams'
import { COLORS, FORMAT, SPACING, TYPOGRAPHY } from 'utils'
import * as Yup from 'yup'

import { DottedLine } from './CreParams.styles'

const CreParams: React.FC = () => {
  const schema = Yup.object({
    dsMascaraNumCre: Yup.string().required('Campo obrigatório'),
    qtdDiasSlaDocMensal: Yup.string().required('Campo obrigatório'),
    qtdDiasSlaPendenciaCre: Yup.string().required('Campo obrigatório'),
    qtdMesesAnaliseCarteiraAntiga: Yup.string().required('Campo obrigatório')
  })

  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors }
  } = useForm<ICreParams>({
    resolver: yupResolver(schema)
  })

  const { loading, msgErro, setLoading, setMsgErro } = useLoading()
  const [isModalOpen, toggleModal] = useToggle()
  const [creParamsData, setCreParamsData] = useState<ICreParams>()
  const { showModal } = useModal()

  const [dsDiaInicioFechamentoAnexoDoc, setDiaInicioFechamentoAnexoDoc] =
    useState(creParamsData?.dsDiaInicioFechamentoAnexoDoc)
  const [diaFechamentoIni, setDiaFechamentoIni] = useState('')
  const onChangediaFechamentoIni = (value) => {
    setDiaFechamentoIni(value)
    setDiaInicioFechamentoAnexoDoc(FORMAT.formatDD(value))
  }
  const [dsDiaFimFechamentoAnexoDoc, setDiaFimFechamentoAnexoDoc] = useState(
    creParamsData?.dsDiaFimFechamentoAnexoDoc
  )
  const [diaFechamentoFim, setDiaFechamentoFim] = useState('')
  const onChangediaFechamentoFim = (value) => {
    setDiaFechamentoFim(value)
    setDiaFimFechamentoAnexoDoc(FORMAT.formatDD(value))
  }

  const updateCreParams = (data) => {
    const anexoDoc = {
      fim: dsDiaFimFechamentoAnexoDoc,
      inicio: dsDiaInicioFechamentoAnexoDoc
    }

    if (hasInvalidDate([anexoDoc.inicio, anexoDoc.fim])) {
      return
    }

    if (rangeIsInvalid(anexoDoc.inicio, anexoDoc.fim)) {
      setLoading('error')
      setMsgErro(
        'A data final deve ser maior que a inicial no fechamento anexo'
      )
      return
    }

    if (data.idParametrizacaoCre > 0) {
      setLoading('loading')
      CreParamsServices()
        .patch({
          ...data,
          qtdDiasSlaDocMensal: parseInt(data.qtdDiasSlaDocMensal),
          qtdDiasSlaPendenciaCre: parseInt(data.qtdDiasSlaPendenciaCre),
          qtdMesesAnaliseCarteiraAntiga: parseInt(
            data.qtdMesesAnaliseCarteiraAntiga
          )
        })
        .then(() => {
          setLoading('idle')
          toggleModal()
        })
        .catch((err) => {
          // setMsgErro(err.title || 'Ocorreu um erro, tente novamente')
          showModal({
            hideButtonCancel: true,
            message: err.title || 'Erro ao obter os dados da pesquisa.',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
          setLoading('error')
        })
    } else {
      setLoading('loading')
      delete data.idParametrizacaoCre
      CreParamsServices()
        .create({
          ...data,
          qtdDiasSlaDocMensal: parseInt(data.qtdDiasSlaDocMensal),
          qtdDiasSlaPendenciaCre: parseInt(data.qtdDiasSlaPendenciaCre),
          qtdMesesAnaliseCarteiraAntiga: parseInt(
            data.qtdMesesAnaliseCarteiraAntiga
          )
        })
        .then((_) => {
          setLoading('idle')
          toggleModal()
        })
        .catch((err) => {
          // setMsgErro(err.title || 'Ocorreu um erro, tente novamente')
          showModal({
            hideButtonCancel: true,
            message: err.title || 'Erro ao obter os dados da pesquisa.',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
          setLoading('error')
        })
    }
  }

  useEffect(() => {
    setLoading('loading')
    CreParamsServices()
      .get()
      .then(({ data }) => {
        setCreParamsData(data[0])
        setValue('qtdDiasSlaDocMensal', data[0]?.qtdDiasSlaDocMensal)
        setValue('qtdDiasSlaPendenciaCre', data[0]?.qtdDiasSlaPendenciaCre)
        setValue(
          'dsDiaInicioFechamentoAnexoDoc',
          data[0]?.dsDiaInicioFechamentoAnexoDoc
        )
        setValue(
          'dsDiaFimFechamentoAnexoDoc',
          data[0]?.dsDiaFimFechamentoAnexoDoc
        )
        setValue(
          'qtdMesesAnaliseCarteiraAntiga',
          data[0]?.qtdMesesAnaliseCarteiraAntiga
        )
        setValue('dsMascaraNumCre', data[0]?.dsMascaraNumCre)
        setDiaInicioFechamentoAnexoDoc(data[0]?.dsDiaInicioFechamentoAnexoDoc)
        setDiaFimFechamentoAnexoDoc(data[0]?.dsDiaFimFechamentoAnexoDoc)
        //Estado inicial do DatePicker
        onChangediaFechamentoIni(
          FORMAT.dayToDate(data[0]?.dsDiaInicioFechamentoAnexoDoc)
        )
        onChangediaFechamentoFim(
          FORMAT.dayToDate(data[0]?.dsDiaFimFechamentoAnexoDoc)
        )

        setLoading('idle')
      })
      .catch((err) => {
        setLoading('error')
        // setMsgErro(err.title || 'Ocorreu um erro, tente novamente')
        showModal({
          hideButtonCancel: true,
          message: err.title || 'Erro ao obter os dados da pesquisa.',
          txtButtonConfirm: 'OK',
          type: 'alert'
        })
      })
  }, [])

  const handleInputClear = () => {
    onChangediaFechamentoIni(null)
    onChangediaFechamentoFim(null)
    reset({
      dsMascaraNumCre: '',
      qtdDiasSlaDocMensal: '',
      qtdDiasSlaPendenciaCre: '',
      qtdMesesAnaliseCarteiraAntiga: ''
    })
  }

  return (
    <>
      <Form
        onSubmit={handleSubmit((data) => {
          updateCreParams({
            ...data,
            dsDiaFimFechamentoAnexoDoc: dsDiaFimFechamentoAnexoDoc,
            dsDiaInicioFechamentoAnexoDoc: dsDiaInicioFechamentoAnexoDoc,
            idParametrizacaoCre:
              creParamsData?.idParametrizacaoCre > 0
                ? creParamsData?.idParametrizacaoCre
                : -1
          })
        })}
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
      >
        <Grid
          gridCols="1fr 1fr 6fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing30} 0`}
        >
          <InputMask
            control={control}
            label="Qtd. Dias SLA Doc Mensal"
            formValue="qtdDiasSlaDocMensal"
            placeholder="Qtd."
            required
            errors={errors}
            type="qtd"
            maxLength={3}
          />
          <InputMask
            control={control}
            label="Qtd. Dias SLA Pendência CRE"
            formValue="qtdDiasSlaPendenciaCre"
            placeholder="Qtd."
            required
            errors={errors}
            type="qtd"
            maxLength={3}
          />
        </Grid>
        <Span
          marginTop={SPACING.spacing5}
          marginBottom={SPACING.spacing5}
          text="Dia Fechamento Anexo Doc"
          color={COLORS.black}
          fontSize={TYPOGRAPHY.bodySize14}
        />
        <Row alignItems="center" gap="1rem">
          <Col>
            <Picker
              type="day"
              allowTyping={false}
              formValue={diaFechamentoIni}
              value={diaFechamentoIni}
              maxDate={moment(diaFechamentoFim).subtract(1, 'd')}
              minDate={moment().startOf('month')}
              onChange={onChangediaFechamentoIni}
              placeholder="Inicial"
            />
            <Span
              marginTop={SPACING.spacing5}
              text={`Início dia: ${dsDiaInicioFechamentoAnexoDoc}`}
              color={withDateColor(dsDiaInicioFechamentoAnexoDoc)}
            />
          </Col>
          <Col>
            <Picker
              type="day"
              allowTyping={false}
              formValue={diaFechamentoFim}
              value={diaFechamentoFim}
              onChange={onChangediaFechamentoFim}
              minDate={moment(diaFechamentoIni).add(1, 'd')}
              maxDate={moment().endOf('month')}
              placeholder="Final"
            />
            <Span
              marginTop={SPACING.spacing5}
              text={`Fim dia: ${dsDiaFimFechamentoAnexoDoc}`}
              color={withDateColor(dsDiaFimFechamentoAnexoDoc)}
            />
          </Col>
        </Row>
        <Span
          marginTop={SPACING.spacing30}
          marginBottom={SPACING.spacing5}
          text="Qtd. Meses Análise Carteira (Antiga)"
          color={COLORS.black}
          fontSize={TYPOGRAPHY.bodySize14}
        />
        <Grid
          gridCols="0.8fr 7.2fr"
          gridGap={`0 ${SPACING.spacing15}`}
          margin={`0 0 ${SPACING.spacing5} 0`}
        >
          <InputMask
            control={control}
            formValue="qtdMesesAnaliseCarteiraAntiga"
            label=""
            placeholder="Qtd."
            required
            errors={errors}
            type="qtd"
            maxLength={3}
          />
        </Grid>
        <DottedLine />
        {/*
        <Grid
          gridCols="0.8fr 7.2fr"
          gridGap={`0 ${SPACING.spacing15}`}
          margin={`${SPACING.spacing5} 0 ${SPACING.spacing5} 0`}
        >
          <InputMask
            control={control}
            formValue="dsMascaraNumCre"
            label="Máscara Nº CRE SHDJAhsd"
            placeholder="Nº"
            required
            errors={errors}
            type="number"
            maxLength={6}
          />
        </Grid>
        */}

        <Row justifyContent="flex-end">
          <Button
            text="Limpar"
            variantButton="text"
            marginLeft={SPACING.spacing15}
            marginRight={SPACING.spacing15}
            onClick={handleInputClear}
          />
          <Button text="Salvar" type="submit" marginLeft={SPACING.spacing20} />
        </Row>
      </Form>
      <SuccessModal
        open={isModalOpen}
        message="Dados foram salvos com sucesso!"
        type="sucess"
        hideButtonCancel
        txtButtonConfirm="OK"
        handleConfirm={() => {
          toggleModal()
        }}
      />
      <SuccessModal
        type="error"
        open={loading === 'error'}
        message={msgErro}
        hideButtonCancel
        txtButtonConfirm="OK"
        handleConfirm={() => setLoading('idle')}
      />
    </>
  )
}

export default CreParams
